<template>
  <div class="payResult-content">
    <div class="pay-result">
      <img :src="require('@/assets/images/paySuccess-pc.svg')" alt="" class="success-icon paySuccess-pc" />
      <img :src="require('@/assets/images/paySuccess-h5.svg')" alt="" class="success-icon paySuccess-h5" />
      <p class="success-text">支付成功</p>
      <p class="result-hint">为了保证你的正常操作，请进行以下操作</p>
      <div class="result-guide">
        <div class="haveRealName-result" v-if="isRealname === true">
          为了保证您的正常操作，请联系企业管理员<span v-if="admin"
            >（ <span>{{ admin.memberName }}</span
            >：<span>{{ admin.mobile }}</span> ）</span
          >前往e签宝官网 <a class="company-website">www.esign.cn</a> 企业控制台-高级数字证书分配授权
        </div>
        <div class="noRealName-result" v-if="isRealname === false">
          <div class="noRealName-row first-row">
            <div class="serial-number">1</div>
            <div class="noRealName-hint">
              检测到当前企业 ( <span>{{ orgInfo.userName }}</span> ) 未实名,请前往e签宝官网
              <a class="company-website">www.esign.cn</a>进行企业实名验证
            </div>
          </div>
          <div class="noRealName-row">
            <div class="serial-number">2</div>
            <div class="noRealName-hint">
              请企业管理员前往e签宝官网
              <a class="company-website">www.esign.cn</a>企业控制台-高级数字证书分配授权
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'result',
  data() {
    return {
      isRealname: null,
      admin: null,
      orgInfo: {},
    }
  },
  created() {
    this.getResult()
  },
  methods: {
    async getResult() {
      const [orgInfo, admin] = await Promise.all([this.getOrgInfo(), this.getAdmin()])
      this.isRealname = !!orgInfo.realNameStatus
      this.orgInfo = orgInfo
      this.admin = admin
    },
    async getOrgInfo() {
      const { data } = await this.$Http.api({
        url: 'webserver/v1/organizations/{orgId}/getOrg',
        method: 'GET',
        params: {
          orgId: this.$route.query.orgId,
        },
      })

      return data
    },
    async getAdmin() {
      const { data } = await this.$Http.api({
        url: 'webserver/v1/organizations/{orgId}/admins',
        method: 'GET',
        params: {
          orgId: this.$route.query.orgId,
        },
      })

      return data.result && data.result[0]
    },
  },
}
</script>

<style lang="less" scoped>
.payResult-content {
  width: 100%;
  min-height: calc(100% - 34px);
  background: #f7f8fa;
  padding: 24px 0 85px;
  .pay-result {
    width: 1200px;
    background: #fff;
    margin: 0 auto;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);
    text-align: center;
    padding-bottom: 149px;
    .success-icon {
      width: 60px;
      height: 60px;
      display: inline-block;
      margin-top: 60px;
    }
    .paySuccess-h5 {
      display: none;
    }
    .paySuccess-pc {
      display: inline-block;
    }
    .success-text {
      height: 25px;
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
      line-height: 25px;
      margin-top: 20px;
    }
    .result-hint {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #1a1a1a;
      line-height: 20px;
      margin-top: 16px;
    }
    .result-guide {
      margin: 30px auto 0;
      width: 680px;
      padding: 24px 30px;
      background: rgba(247, 248, 250, 1);
      border: 1px solid rgba(228, 228, 228, 1);
      color: #1a1a1a;
      border-radius: 2px;
      text-align: left;
      line-height: 24px;
      font-size: 14px;
      .company-website {
        color: #0975e1;
        cursor: pointer;
      }
      .noRealName-result {
        padding: 0 10px;
        .noRealName-row {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          .serial-number {
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 50%;
            background: #0975e0;
            font-size: 9px;
            color: #fff;
            text-align: center;
            margin: 2px 8px 0 0;
          }
          .noRealName-hint {
            flex: 1;
          }
        }

        .first-row {
          margin-bottom: 24px;
          .noRealName-hint {
            position: relative;
            &::before {
              content: '';
              display: block;
              width: 1px;
              height: 100%;
              background: #cccccc;
              position: absolute;
              left: -18px;
              top: 24px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .payResult-content {
    background: #fff;
    min-height: calc(100% - 41px);
    padding: 0;
    .pay-result {
      width: 100%;
      padding-bottom: 0;
      box-shadow: none;
      .success-icon {
        margin: 40px auto 0;
      }
      .paySuccess-pc {
        display: none;
      }
      .paySuccess-h5 {
        display: inline-block;
      }
      .result-guide {
        width: 315px;
        background: #fff;
        border: none;
        padding: 0;
        margin: 6px auto 0;
        .haveRealName-result {
          text-align: center;
        }
        .noRealName-result {
          padding: 0;
          margin-top: 42px;
          .noRealName-hint {
            width: 287px;
          }
        }
      }
    }
  }
}
</style>
